import { ArrowRight, CircleDashed, MessageCircle, ShieldCheck, UsersRound } from 'lucide-react';

function getWorkspaceContent(title) {
  const content = {
    SMS: {
      kicker: 'Communication workspace',
      title: 'Keep every learner in the loop.',
      body: 'Send timely reminders, admissions updates, fee notices and class alerts to the people who need them.',
      icon: MessageCircle,
      steps: ['Connect your SMS sender', 'Create reusable message templates', 'Track delivery and replies'],
    },
    WhatsApp: {
      kicker: 'Communication workspace',
      title: 'Meet your community where they are.',
      body: 'Build a direct WhatsApp path for enquiries, applications, confirmations, reminders and everyday support.',
      icon: MessageCircle,
      steps: ['Connect your WhatsApp number', 'Set up guided conversations', 'Keep every reply in context'],
    },
    Email: {
      kicker: 'Communication workspace',
      title: 'Make every message feel considered.',
      body: 'Send onboarding, learning, finance and progress communication with a dependable record of every conversation.',
      icon: MessageCircle,
      steps: ['Connect your sending identity', 'Build branded templates', 'Measure delivery and engagement'],
    },
    'HR Overview': {
      kicker: 'People operations',
      title: 'Give your team a better place to work.',
      body: 'Bring staff records, hiring, attendance, leave, remote teams, payroll context and everyday people operations into one view.',
      icon: UsersRound,
      steps: ['Set up your people directory', 'Invite roles and managers', 'Create your team operating rhythm'],
    },
  };
  return content[title] || {
    kicker: 'SmartCampus workspace',
    title: `${title} is ready to take shape.`,
    body: 'Bring this part of your education business into the same connected workspace as your learners, team and operations.',
    icon: ShieldCheck,
    steps: ['Set up the workspace', 'Connect the right information', 'Move the next task forward'],
  };
}

export function DashboardPlaceholderPage({
  title,
  description,
  message,
}) {
  const workspace = getWorkspaceContent(title);
  const WorkspaceIcon = workspace.icon;

  return (
    <div className={`page-stack dashboard-placeholder-page dashboard-placeholder-page--${String(title).toLowerCase().replace(/[^a-z0-9]+/g, '-')}`}>
      <section className="dashboard-placeholder-hero">
        <span className="dashboard-placeholder-icon"><WorkspaceIcon size={22} /></span>
        <div>
          <p>{workspace.kicker}</p>
          <h1>{title}</h1>
          <span>{description}</span>
        </div>
      </section>
      <section className="dashboard-placeholder-panel">
        <div className="dashboard-placeholder-copy">
          <span className="dashboard-placeholder-kicker">Your next operating layer</span>
          <h2>{workspace.title}</h2>
          <p>{workspace.body}</p>
          <span className="dashboard-placeholder-status"><CircleDashed size={14} /> {message || 'Workspace setup in progress'}</span>
        </div>
        <div className="dashboard-placeholder-steps">
          {workspace.steps.map((step, index) => <article key={step}><b>{String(index + 1).padStart(2, '0')}</b><span>{step}</span><ArrowRight size={15} /></article>)}
        </div>
      </section>
    </div>
  );
}
